import { Button, FullScreenLoading } from '@civilgrid/ui/components';
import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { type SubmitHandler, useForm } from 'react-hook-form';
import { createSandboxOrg as apiCreateSandboxOrg } from '~/api/internal';
import Form from '~/components2/forms/Form';
import { Notify } from '~/components2/Notify';
import rootStore from '~/store';
import Field from '../common/Field';
import { MajorHeading } from '../common/Heading';
import type { SandboxOrgFormValues } from './common';

export default function CreateSandboxOrg() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { handleSubmit, control } = useForm<SandboxOrgFormValues>({
    defaultValues: {
      orgName: '',
    },
  });

  const onSubmit: SubmitHandler<SandboxOrgFormValues> = async (data) => {
    try {
      setIsLoading(true);
      const orgName = data.orgName;

      const res = await apiCreateSandboxOrg(orgName);

      if (!res.success) {
        throw new Error('Error creating sandbox org');
      }

      await rootStore.refreshMe();

      if (res.id) {
        await rootStore.setCurrentOrganization(res.id);
      }

      Notify.info({
        title: 'Success',
        message: 'Sandbox Organization successfully created',
      });
      navigate({ to: '/home' });
    } catch {
      Notify.error({
        title: 'Error',
        message: 'Error creating new Sandbox Organization',
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <MajorHeading>Enter Sandbox Org Details</MajorHeading>

      <Field
        id="orgName"
        label="Enter Sandbox Org name"
        control={control}
        placeholder="Ex: ACME Engineers"
        tooltipText='A specified name of "ACME Engineers" will result in the Org Name being "ACME Engineers (SANDBOX)'
      />

      <Button type="submit">Submit</Button>
    </Form>
  );
}
